import session from '@api/session'
import { APIEndpoint } from '@api/_version'

export default {
  createCampaign(data) {
    // name, user, widgetItems
    return session.post(APIEndpoint + '/api/campaigns/', data)
  },
  getCampaign(campaignID) {
    return session.get(APIEndpoint + '/api/campaigns/' + campaignID + '/', {
      campaignID,
    })
  },
  getAllCampaigns() {
    return session.get(APIEndpoint + '/api/campaigns/')
  },
  saveCampaign(campaign) {
    return session.put(APIEndpoint + '/api/campaigns/' + campaign.uuid + '/', campaign)
  },
  partialSaveCampaign(campaign) {
    return session.patch(APIEndpoint + '/api/campaigns/' + campaign.uuid + '/', campaign)
  },
  deleteCampaign(campaignUUID) {
    return session.delete(APIEndpoint + '/api/campaigns/' + campaignUUID + '/', {
      campaignUUID,
    })
  },
  createWidget(widget) {
    const data = widget
    return session.post(APIEndpoint + '/api/widgets/', data)
  },
  saveWidget(widget) {
    return session.put(APIEndpoint + '/api/widgets/' + widget.id + '/', widget)
  },
  deleteWidget(id) {
    return session.delete(APIEndpoint + '/api/widgets/' + id + '/', { id })
  },
  checkEmbedCodePresence() {
    return session.get(APIEndpoint + '/api/check-embedded-code/')
  },
  /* --- AWS Bucket --- */
  uploadFile(file, s3Data) {
    if (process.env.NODE_ENV === 'production') {
      return this.uploadFileBucket(file, s3Data)
    } else {
      return this.uploadFileLocal(file, s3Data)
    }
  },
  uploadFileBucket(file, s3Data) {
    const postData = new FormData()

    for (const key in s3Data.data.fields) {
      postData.append(key, s3Data.data.fields[key])
    }

    postData.append('file', file)

    return session({
      method: 'post',
      url: s3Data.data.url,
      data: postData,
      // Hacky way to remove the Authorization header from axios
      transformRequest: [
        (data, headers) => {
          delete headers.Authorization
          return data
        },
      ],
    })
  },
  uploadFileLocal(file) {
    const postData = new FormData()

    postData.append('file', file)

    return session({
      method: 'post',
      url: APIEndpoint + '/api/s3local/',
      data: postData,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getSignedRequest(fileName, fileType) {
    return session.post(APIEndpoint + '/api/s3/', {
      file_name: fileName,
      file_type: fileType,
    })
  },
}
